import React from 'react';

import classNames from 'classnames';

import HubspotForm from '../HubspotForm';
import TextHeader from '../TextHeader';
import ContactPanelStyles from './ContactPanel.module.scss';
import { IContact } from './ContactPanel.types';

interface ContactProps {
  data: IContact;
  customCss: boolean;
}

const ClientsContactPanel: React.FC<ContactProps> = ({
  data: { label, description, formId },
  customCss,
}) => {
  const header = {
    title: label,
    description: [description],
  };

  return (
    <div className={classNames(ContactPanelStyles.clientsContactPanel)}>
      <div className={ContactPanelStyles.textHeaderWrapper}>
        <TextHeader level={2} data={header} />
      </div>

      <div className={ContactPanelStyles.formWrapper}>
        <HubspotForm formId={formId} customCss={customCss} />
      </div>
    </div>
  );
};

export default ClientsContactPanel;
